import { ApiUtility, IApiListResult } from "../../Utilities/ApiUtility.axios";
import { IFileNameModel } from "./VoucherServices";

export interface ICategoryMaintainCheckbox {
  maintainLocation: boolean;
  maintainModel: boolean;
  maintainIdentityMark: boolean;
  maintainWarranty: boolean;
  maintainVariant: boolean;
  maintainOption: boolean;
  maintainEmployeeAssign: boolean;
}

export interface IFACategoryList
  extends ICategoryMaintainCheckbox,
    ICategoryTable {}

export interface ICategoryTable {
  id?: string;
  categoryName: string;
  parentCategoryId?: string;
  parentCategoryName?: string;
  assetCategoryType?: AssetCategories_Type;
  deleteUploadId?: string[];
  attachments?: IFileNameModel[];
}

export enum AssetCategories_Type {
  Unspecified, // Others
  Buildings, // Buildings
  BridgesCulvertsBunkers, // Bridges, Culverts, Bunkers, Etc.
  Roads, // Roads
  PlantnMachinery, // Plant and Machinery
  FurniturenFittings, // Furniture and fittings
  MotorVehicles, // Motor Vehicles
  Ships, // Ships
  AircraftsnHelicopters, // Aircrafts or Helicopters
  RailwaySidingLocomotivesRollingStocksnTramways, // Railway siding, locomotives, rolling stocks, tramways and railway used by concerns, excluding railway
  RopewayStructures, // Ropeway structures
  OfficeEquipments, // Office equipments
  ComputersnDataProcessingUnits, // Computers and data processing units
  LaboratoryEquipment, // Laboratory equipment
  ElectricalInstallationsnEquipment, // Electrical Installations and Equipment
  HydraulicWoksPipelinesnSluices, //Hydraulic woks, pipelines and sluices
}
export const AssetCategoriesTypesList = [
  {
    value: AssetCategories_Type.Buildings,
    label: "Buildings",
  }, // Buildings
  {
    value: AssetCategories_Type.BridgesCulvertsBunkers,
    label: "Bridges, Culverts, Bunkers, Etc.",
  }, // Bridges, Culverts, Bunkers, Etc.
  {
    value: AssetCategories_Type.Roads,
    label: "Roads",
  }, // Roads
  {
    value: AssetCategories_Type.PlantnMachinery,
    label: "Plant & Machinery",
  }, // Plant and Machinery
  {
    value: AssetCategories_Type.FurniturenFittings,
    label: "Furniture & Fittings",
  }, // Furniture and fittings
  {
    value: AssetCategories_Type.MotorVehicles,
    label: "Motor Vehicles",
  }, // Motor Vehicles
  {
    value: AssetCategories_Type.Ships,
    label: "Ships",
  }, // Ships
  {
    value: AssetCategories_Type.AircraftsnHelicopters,
    label: "Aircrafts or Helicopters",
  }, // Aircrafts or Helicopters
  {
    value: AssetCategories_Type.RailwaySidingLocomotivesRollingStocksnTramways,
    label:
      "Railway siding, locomotives, rolling stocks, tramways and railway used by concerns, excluding railway",
  }, // Railway siding, locomotives, rolling stocks, tramways and railway used by concerns, excluding railway
  {
    value: AssetCategories_Type.RopewayStructures,
    label: "Ropeway Structures",
  }, // Ropeway structures
  {
    value: AssetCategories_Type.OfficeEquipments,
    label: "Office Equipments",
  }, // Office equipments
  {
    value: AssetCategories_Type.ComputersnDataProcessingUnits,
    label: "Computers & Data Processing Units",
  }, // Computers and data processing units
  {
    value: AssetCategories_Type.LaboratoryEquipment,
    label: "Laboratory Equipment",
  }, // Laboratory equipment
  {
    value: AssetCategories_Type.ElectricalInstallationsnEquipment,
    label: "Electrical Installations & Equipment",
  }, // Electrical Installations and Equipment
  {
    value: AssetCategories_Type.HydraulicWoksPipelinesnSluices,
    label: "Hydraulic Woks, Pipelines & Sluices",
  }, //Hydraulic woks, pipelines and sluices
  {
    value: AssetCategories_Type.Unspecified,
    label: "Other",
  },
];

class AssetCategoriesService {
  route = `V1/API/Billing/Acc_FACategories`;

  getCategoriesList = (
    companyId: string | undefined,
    start?: number,
    length?: number,
    search?: string
  ) =>
    ApiUtility.getResult<IApiListResult<IFACategoryList>>(
      `${this.route}/${companyId}/GetFACategoriesList?start=${start}&length=${length}&search=${search}`
    );

  getCategoryDatabyId = (companyId: string | undefined, FACategoryId: string) =>
    ApiUtility.get(`${this.route}/${companyId}/${FACategoryId}`);

  deleteCategoryDatabyId = (
    companyId: string | undefined,
    FACategoryId: string
  ) => ApiUtility.delete(`${this.route}/${companyId}/${FACategoryId}`);

  postCategoryData = (
    companyId: string | undefined,
    modal: any,
    FACategoryId?: string
  ) =>
    ApiUtility.post(
      `${this.route}/${companyId}/${FACategoryId ? FACategoryId : ""}`,
      modal
    );
}
export default new AssetCategoriesService();
